const IconTransfer = () => (
  <svg
    fill="none"
    height="41"
    viewBox="0 0 41 41"
    width="41"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.5" cy="20.5" fill="#FFECDA" r="20.5" />
    <g clipPath="url(#clip0_1125_99175)">
      <path
        clipRule="evenodd"
        d="M11.2814 23.5314C12.1019 22.7109 13.2147 22.25 14.375 22.25H21.375C22.5353 22.25 23.6481 22.7109 24.4686 23.5314C25.2891 24.3519 25.75 25.4647 25.75 26.625V28.375C25.75 28.8582 25.3582 29.25 24.875 29.25C24.3917 29.25 24 28.8582 24 28.375V26.625C24 25.9288 23.7234 25.2611 23.2312 24.7688C22.7389 24.2766 22.0712 24 21.375 24H14.375C13.6788 24 13.0111 24.2766 12.5188 24.7688C12.0266 25.2611 11.75 25.9288 11.75 26.625V28.375C11.75 28.8582 11.3582 29.25 10.875 29.25C10.3918 29.25 10 28.8582 10 28.375V26.625C10 25.4647 10.4609 24.3519 11.2814 23.5314Z"
        fill="#FF7A00"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M17.875 13.5C16.4253 13.5 15.25 14.6753 15.25 16.125C15.25 17.5747 16.4253 18.75 17.875 18.75C19.3247 18.75 20.5 17.5747 20.5 16.125C20.5 14.6753 19.3247 13.5 17.875 13.5ZM13.5 16.125C13.5 13.7088 15.4588 11.75 17.875 11.75C20.2912 11.75 22.25 13.7088 22.25 16.125C22.25 18.5412 20.2912 20.5 17.875 20.5C15.4588 20.5 13.5 18.5412 13.5 16.125Z"
        fill="#FF7A00"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M26.6528 23.0197C26.7736 22.5518 27.2508 22.2705 27.7187 22.3913C28.6573 22.6336 29.4888 23.1808 30.0827 23.9469C30.6766 24.7131 30.9992 25.6547 31 26.6241L31 28.3747C31 28.858 30.6082 29.2497 30.125 29.2497C29.6417 29.2497 29.25 28.858 29.25 28.3747L29.25 26.6254C29.25 26.6253 29.25 26.6255 29.25 26.6254C29.2495 26.0439 29.0559 25.4787 28.6996 25.0191C28.3433 24.5594 27.8444 24.2311 27.2812 24.0857C26.8133 23.9649 26.5319 23.4876 26.6528 23.0197Z"
        fill="#FF7A00"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M23.1524 12.5215C23.2722 12.0533 23.7489 11.771 24.2171 11.8908C25.1581 12.1318 25.9923 12.6791 26.5879 13.4465C27.1836 14.2139 27.5069 15.1577 27.5069 16.1291C27.5069 17.1006 27.1836 18.0444 26.5879 18.8117C25.9923 19.5791 25.1581 20.1264 24.2171 20.3674C23.7489 20.4873 23.2722 20.2049 23.1524 19.7368C23.0325 19.2686 23.3148 18.7919 23.783 18.6721C24.3476 18.5275 24.8481 18.1991 25.2055 17.7387C25.5629 17.2783 25.7569 16.712 25.7569 16.1291C25.7569 15.5463 25.5629 14.98 25.2055 14.5195C24.8481 14.0591 24.3476 13.7307 23.783 13.5861C23.3148 13.4663 23.0325 12.9896 23.1524 12.5215Z"
        fill="#FF7A00"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_1125_99175">
        <rect
          fill="white"
          height="21"
          transform="translate(10 10)"
          width="21"
        />
      </clipPath>
    </defs>
  </svg>
);

const IconBalance = () => (
  <svg
    fill="none"
    height="41"
    viewBox="0 0 41 41"
    width="41"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.5" cy="20.5" fill="#D4F5EE" r="20.5" />
    <path
      d="M21 31C26.523 31 31 26.523 31 21C31 15.477 26.523 11 21 11C15.477 11 11 15.477 11 21C11 26.523 15.477 31 21 31Z"
      stroke="#267F5F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M21 25.391V27.5M24 17.5C23.315 16.815 22.109 16.339 21 16.309L24 17.5ZM18 24C18.644 24.86 19.843 25.35 21 25.391L18 24ZM21 16.309C19.68 16.273 18.5 16.87 18.5 18.5C18.5 21.5 24 20 24 23C24 24.711 22.536 25.446 21 25.391V16.309ZM21 16.309V14.5V16.309Z"
      stroke="#267F5F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

const IconPremium = () => (
  <svg
    fill="none"
    height="41"
    viewBox="0 0 41 41"
    width="41"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.5" cy="20.5" fill="#FEF6BD" r="20.5" />
    <path
      clipRule="evenodd"
      d="M20.5 10.875C20.8331 10.875 21.1372 11.0641 21.2846 11.3627L23.785 16.4282L29.3766 17.2455C29.7061 17.2936 29.9797 17.5246 30.0824 17.8414C30.1851 18.1581 30.0991 18.5057 29.8605 18.7381L25.8152 22.6782L26.7699 28.2446C26.8262 28.5729 26.6913 28.9047 26.4218 29.1004C26.1523 29.2962 25.7951 29.322 25.5003 29.1669L20.5 26.5374L15.4998 29.1669C15.205 29.322 14.8477 29.2962 14.5783 29.1004C14.3088 28.9047 14.1738 28.5729 14.2301 28.2446L15.1848 22.6782L11.1395 18.7381C10.901 18.5057 10.815 18.1581 10.9177 17.8414C11.0204 17.5246 11.294 17.2936 11.6235 17.2455L17.215 16.4282L19.7154 11.3627C19.8628 11.0641 20.167 10.875 20.5 10.875ZM20.5 13.7268L18.5809 17.6148C18.4535 17.8728 18.2075 18.0517 17.9228 18.0933L13.6299 18.7208L16.7355 21.7457C16.9419 21.9467 17.0361 22.2365 16.9874 22.5204L16.2547 26.7927L20.0928 24.7743C20.3477 24.6402 20.6523 24.6402 20.9073 24.7743L24.7454 26.7927L24.0126 22.5204C23.9639 22.2365 24.0581 21.9467 24.2645 21.7457L27.3702 18.7208L23.0772 18.0933C22.7925 18.0517 22.5465 17.8728 22.4192 17.6148L20.5 13.7268Z"
      fill="#BA9C06"
      fillRule="evenodd"
    />
  </svg>
);

const IconPins = () => (
  <svg
    fill="none"
    height="41"
    viewBox="0 0 41 41"
    width="41"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.5" cy="20.5" fill="#E3EAFF" r="20.5" />
    <g clipPath="url(#clip0_1125_99175)">
      <path
        d="M16.26 27V14.04H21.615C21.741 14.04 21.903 14.046 22.101 14.058C22.299 14.064 22.482 14.082 22.65 14.112C23.4 14.226 24.018 14.475 24.504 14.859C24.996 15.243 25.359 15.729 25.593 16.317C25.833 16.899 25.953 17.547 25.953 18.261C25.953 18.969 25.833 19.617 25.593 20.205C25.353 20.787 24.987 21.27 24.495 21.654C24.009 22.038 23.394 22.287 22.65 22.401C22.482 22.425 22.296 22.443 22.092 22.455C21.894 22.467 21.735 22.473 21.615 22.473H18.429V27H16.26ZM18.429 20.448H21.525C21.645 20.448 21.78 20.442 21.93 20.43C22.08 20.418 22.218 20.394 22.344 20.358C22.704 20.268 22.986 20.109 23.19 19.881C23.4 19.653 23.547 19.395 23.631 19.107C23.721 18.819 23.766 18.537 23.766 18.261C23.766 17.985 23.721 17.703 23.631 17.415C23.547 17.121 23.4 16.86 23.19 16.632C22.986 16.404 22.704 16.245 22.344 16.155C22.218 16.119 22.08 16.098 21.93 16.092C21.78 16.08 21.645 16.074 21.525 16.074H18.429V20.448Z"
        fill="#3366FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1125_99175">
        <rect
          fill="white"
          height="21"
          transform="translate(10 10)"
          width="21"
        />
      </clipPath>
    </defs>
  </svg>
);

type Props = {
  movementType: string;
};

export const IconMovements = ({ movementType }: Props) => {
  const iconsMap: { [key: string]: React.ElementType } = {
    transferencia: IconTransfer,
    carga: IconBalance,
    premium: IconPremium,
    pin: IconPins,
    pack: IconPins,
  };

  const IconToShow = iconsMap[movementType] || null;

  return IconToShow ? <IconToShow /> : null;
};
